export default __webpack_public_path__ + "static/media/Giuria (3).9c24d838.jpg";